import { PlusIcon } from '@langchain/untitled-ui-icons';

import { Button } from '@/design-system';
import { useRunRules } from '@/hooks/useSwr';

import { PlaygroundButton } from '../Playground/PlaygroundHome/PlaygroundButtons';

export function DatasetRuleButton({
  datasetId: datasetId,
  onClick,
  variant = 'dataset',
  minimized,
  customNumRules,
}: {
  datasetId: string;
  onClick: () => void;
  variant?: 'dataset' | 'playground';
  minimized?: boolean;
  customNumRules?: number;
}) {
  const rules = useRunRules({ dataset_id: datasetId });
  const nRules =
    customNumRules != undefined ? customNumRules : rules.data?.length ?? 0;

  if (variant === 'playground') {
    return (
      <PlaygroundButton
        text={
          nRules === 0
            ? minimized
              ? 'Eval'
              : 'Evaluator'
            : minimized
            ? 'Evals'
            : 'Evaluators'
        }
        onClick={onClick}
        startDecorator={
          nRules === 0 ? <PlusIcon className="my-auto h-4 w-4" /> : null
        }
        endDecorator={
          nRules > 0 ? (
            <div className="ml-0.5 rounded-md bg-tertiary px-1.5">{nRules}</div>
          ) : undefined
        }
        tooltipTitle="Add an evaluator to assess the quality of the model's output"
        className="py-1"
      />
    );
  } else {
    return (
      <Button
        leftDecorator={PlusIcon}
        onClick={onClick}
        color="primary"
        variant="outlined"
        size="md"
      >
        Evaluator
      </Button>
    );
  }
}
